<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-11 00:49 -->
<!-- Description:  -->
<template>
  <div>
    <RoleForm :key="`${reg.id}_`" :content="reg"></RoleForm>
    <!-- <RoleForm :content="reg"></RoleForm> -->
    <h4>LISTA DE PERMISOS</h4>
    <RolePermissions :roleId="id" :key="id"></RolePermissions>
  </div>
</template>
<script>
//import RoleForm from "./RoleForm.vue";
import AdminService from "../AdminService.js";
import RolePermissions from "./RolePermissions.vue";
import RoleForm from "./RoleForm.vue";

// script content
export default {
  name: "RoleFormView",
  components: {
    RoleForm,
    RolePermissions,
  },

  // directives

  props: {
    id: {}
  },

  data: () => ({
    reg: {},
  }),

  computed: {
    //
  },

  // watch: {},

  async mounted() {
    let res = await AdminService.getRole(this.id);
    this.reg = res;
  },

  methods: {
    //
    //
  }
};
</script>
<style scoped></style>
